import classNames from 'classnames';
import Money from 'components/generics/texts/Money';
import {
  cashColor,
  loanColor,
} from 'pages/lend/components/LandaFinancingUtilizationRate/utils';
import React from 'react';
import classes from './index.module.scss';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  loansBalance: number;
  cashBalance: number;
}

const UtilizationGraphLegend = ({
  loansBalance,
  cashBalance,
  className,
}: Props) => {
  const legendItems = [
    {
      title: 'MORTGAGES',
      value: loansBalance,
      color: loanColor,
    },
    {
      title: 'CASH',
      value: cashBalance,
      color: cashColor,
    },
  ];
  return (
    <div className={classNames(classes.container, className)}>
      {legendItems.map(({ title, value, color }, index) => (
        <div
          className={classes.box}
          key={index}
        >
          <div className={classes.topContainer}>
            <div
              className={classes.circle}
              style={{ backgroundColor: color }}
            />
            <div className={classes.text}>{title}</div>
          </div>
          <Money
            className={classes.money}
            value={value}
            withDecimal={true}
          />
        </div>
      ))}
    </div>
  );
};

export default UtilizationGraphLegend;
